<div class="claim-status-chart-layout" [class.claim-status-chart-layout--empty]="!hasData">
  @if (hasData) {
  <div class="claim-status-chart__plot">
    <apx-chart #chart [series]="chartOptions.series" [chart]="chartOptions.chart" [labels]="chartOptions.labels"
      [colors]="chartOptions.colors!" [plotOptions]="chartOptions.plotOptions" [stroke]="chartOptions.stroke"
      [legend]="chartOptions.legend!" [tooltip]="chartOptions.tooltip!" [responsive]="chartOptions.responsive"
      [dataLabels]="chartOptions.dataLabels!">
    </apx-chart>
  </div>
  } @else {
  <app-dashboard-chart-empty-state messageKey="dashboard.no_filed_cases" />
  }

  @if (hasData && legendItems.length) {  <div class="claim-status-chart__legend" role="list">
    @for (item of legendItems; track item.statusValue) {
    <button type="button" class="claim-status-chart__legend-item" role="listitem"
      [matTooltip]="getLegendItemTooltip(item.label)"
      (click)="onLegendItemClick(item.statusValue)">
      <span class="claim-status-chart__legend-marker" [style.backgroundColor]="item.color"></span>
      <span class="claim-status-chart__legend-label">{{ truncateLegendLabel(item.label) }}</span>
      <span class="claim-status-chart__legend-count">{{ item.total }}</span>
    </button>
    }
  </div>
  }
</div>
